import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl
  implements OnDestroy {
  unsubscribe: Subject<void> = new Subject<void>();
  ofLabel = 'of';
  suffix = "";

  constructor(private translate: TranslateService) {
    super();

    this.translate.onLangChange.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.getAndInitTranslations();
    });

    this.getAndInitTranslations();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getAndInitTranslations() {
    this.translate
      .get([
        'label.paginator.itemsPerPage',
        'label.paginator.ofLabel',
        "label.paginator.firstPageLabel",
        "label.paginator.lastPageLabel",
        "label.paginator.nextPageLabel",
        "label.paginator.previousPageLabel",
        "label.paginator.suffix"

      ]).pipe(
        takeUntil(this.unsubscribe))
      .subscribe(translation => {
        this.itemsPerPageLabel = translation['label.paginator.itemsPerPage'];
        this.ofLabel = translation['label.paginator.ofLabel'];
        this.firstPageLabel = translation["label.paginator.firstPageLabel"];
        this.lastPageLabel = translation["label.paginator.lastPageLabel"];
        this.nextPageLabel = translation["label.paginator.nextPageLabel"];
        this.previousPageLabel = translation["label.paginator.previousPageLabel"];
        this.suffix = translation["label.paginator.suffix"];
        this.changes.next();

      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number,) => {
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    if (length === 0 || pageSize === 0) {
      return `0 ${this.ofLabel} ${length} ${this.suffix}`;
    }
    return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${length} ${this.suffix}`;

  };
}